var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayAppStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 165,
    height: 50,
    viewBox: "0 0 165 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.720076,
    y: 1.33726,
    width: 163.668,
    height: 47.6347,
    rx: 5.49631,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.720076,
    y: 1.33726,
    width: 163.668,
    height: 47.6347,
    rx: 5.49631,
    stroke: "#A6A6A6",
    strokeWidth: 1.2214
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.327 27.2933C80.4543 27.2933 78.1129 29.4784 78.1129 32.488C78.1129 35.4792 80.4543 37.6826 83.327 37.6826C86.201 37.6826 88.5424 35.4792 88.5424 32.488C88.5412 29.4784 86.1998 27.2933 83.327 27.2933ZM83.327 35.6379C81.7527 35.6379 80.3957 34.3396 80.3957 32.4892C80.3957 30.6192 81.7539 29.3404 83.327 29.3404C84.9014 29.3404 86.2584 30.6192 86.2584 32.4892C86.2584 34.3384 84.9014 35.6379 83.327 35.6379ZM71.9509 27.2933C69.0782 27.2933 66.7367 29.4784 66.7367 32.488C66.7367 35.4792 69.0782 37.6826 71.9509 37.6826C74.8249 37.6826 77.1663 35.4792 77.1663 32.488C77.1663 29.4784 74.8249 27.2933 71.9509 27.2933ZM71.9509 35.6379C70.3765 35.6379 69.0195 34.3396 69.0195 32.4892C69.0195 30.6192 70.3777 29.3404 71.9509 29.3404C73.5253 29.3404 74.8823 30.6192 74.8823 32.4892C74.8835 34.3384 73.5253 35.6379 71.9509 35.6379ZM58.4202 28.8885V31.0919H63.6942C63.5367 32.3316 63.1238 33.2367 62.4936 33.8657C61.7265 34.6327 60.5259 35.4792 58.4202 35.4792C55.1737 35.4792 52.6357 32.8617 52.6357 29.6152C52.6357 26.3687 55.1737 23.7513 58.4202 23.7513C60.1717 23.7513 61.4505 24.4401 62.3947 25.3256L63.9495 23.7708C62.6304 22.5115 60.8801 21.5479 58.4202 21.5479C53.9731 21.5479 50.2344 25.1681 50.2344 29.6152C50.2344 34.0623 53.9731 37.6826 58.4202 37.6826C60.8203 37.6826 62.6316 36.8948 64.0472 35.4193C65.5031 33.9634 65.9563 31.9163 65.9563 30.2638C65.9563 29.7532 65.9172 29.2805 65.8378 28.8873H58.4202V28.8885ZM113.76 30.5997C113.327 29.4393 112.008 27.2933 109.312 27.2933C106.636 27.2933 104.412 29.399 104.412 32.488C104.412 35.3998 106.617 37.6826 109.568 37.6826C111.948 37.6826 113.326 36.2267 113.898 35.3802L112.126 34.1991C111.537 35.0651 110.729 35.6355 109.568 35.6355C108.407 35.6355 107.58 35.1042 107.049 34.0611L113.995 31.1884L113.76 30.5997ZM106.675 32.3316C106.617 30.3236 108.23 29.3013 109.392 29.3013C110.297 29.3013 111.064 29.7545 111.32 30.403L106.675 32.3316ZM101.029 37.3687H103.31V22.0999H101.029V37.3687ZM97.2889 28.4549H97.2107C96.699 27.8442 95.7145 27.2933 94.476 27.2933C91.8781 27.2933 89.4976 29.5761 89.4976 32.5087C89.4976 35.4205 91.8781 37.6838 94.476 37.6838C95.7157 37.6838 96.699 37.1329 97.2107 36.5039H97.2889V37.2514C97.2889 39.2386 96.2263 40.3013 94.5151 40.3013C93.1178 40.3013 92.2518 39.2985 91.8976 38.4521L89.9104 39.2789C90.4808 40.6555 91.9953 42.3483 94.5151 42.3483C97.1912 42.3483 99.4544 40.7739 99.4544 36.9363V27.6097H97.2901V28.4549H97.2889ZM94.6727 35.6379C93.0983 35.6379 91.7804 34.3188 91.7804 32.5087C91.7804 30.6778 93.0983 29.3404 94.6727 29.3404C96.2263 29.3404 97.4465 30.6778 97.4465 32.5087C97.4465 34.3188 96.2263 35.6379 94.6727 35.6379ZM124.452 22.0999H118.991V37.3687H121.269V31.5841H124.45C126.976 31.5841 129.461 29.7557 129.461 26.8426C129.461 23.9296 126.978 22.0999 124.452 22.0999ZM124.51 29.4589H121.269V24.2252H124.51C126.214 24.2252 127.181 25.6359 127.181 26.8426C127.181 28.0249 126.214 29.4589 124.51 29.4589ZM138.595 27.2665C136.945 27.2665 135.237 27.9932 134.529 29.6042L136.552 30.4482C136.984 29.6042 137.791 29.3282 138.635 29.3282C139.813 29.3282 141.011 30.0354 141.031 31.2922V31.4498C140.618 31.214 139.734 30.861 138.654 30.861C136.474 30.861 134.253 32.0592 134.253 34.2981C134.253 36.3415 136.042 37.6569 138.045 37.6569C139.576 37.6569 140.421 36.9693 140.952 36.1632H141.03V37.3418H143.231V31.4876C143.232 28.7786 141.207 27.2665 138.595 27.2665ZM138.319 35.6343C137.574 35.6343 136.533 35.2605 136.533 34.3372C136.533 33.1585 137.83 32.7066 138.95 32.7066C139.95 32.7066 140.423 32.9228 141.031 33.2171C140.854 34.6327 139.636 35.6343 138.319 35.6343ZM151.246 27.5999L148.633 34.2199H148.555L145.843 27.5999H143.388L147.454 36.852L145.136 41.999H147.513L153.78 27.5999H151.246ZM130.719 37.3687H132.997V22.0999H130.719V37.3687Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0262 13.2372C58.0262 14.2607 57.7233 15.0754 57.1163 15.6836C56.4274 16.4067 55.5284 16.7682 54.4243 16.7682C53.3666 16.7682 52.4664 16.4018 51.7274 15.669C50.9873 14.9349 50.6172 14.0262 50.6172 12.9416C50.6172 11.8558 50.9873 10.947 51.7274 10.2142C52.4664 9.48013 53.3666 9.11371 54.4243 9.11371C54.9495 9.11371 55.4515 9.21631 55.9278 9.42029C56.4054 9.62548 56.7877 9.89785 57.0735 10.2386L56.4298 10.8835C55.9449 10.3034 55.2768 10.0139 54.4231 10.0139C53.6511 10.0139 52.9843 10.285 52.4212 10.8273C51.8581 11.3696 51.5772 12.0744 51.5772 12.9404C51.5772 13.8063 51.8581 14.5111 52.4212 15.0534C52.9843 15.5957 53.6511 15.8668 54.4231 15.8668C55.2414 15.8668 55.9242 15.5945 56.4701 15.0485C56.8244 14.6931 57.0295 14.1984 57.0845 13.5645H54.4231V12.6839H57.9737C58.0103 12.8756 58.0262 13.0601 58.0262 13.2372Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.657 10.1764H60.3201V12.4995H63.3297V13.3801H60.3201V15.7032H63.657V16.6046H59.3784V9.27623H63.657V10.1764Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6276 16.6046H66.6859V10.1764H64.6389V9.27623H69.6747V10.1764H67.6276V16.6046Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3181 16.6046V9.27623H74.2598V16.6046H73.3181Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M78.436 16.6046H77.4943V10.1764H75.4472V9.27623H80.483V10.1764H78.436V16.6046Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0158 15.658C89.2952 16.3982 88.3999 16.7683 87.3287 16.7683C86.2575 16.7683 85.3623 16.3982 84.6429 15.658C83.9222 14.9179 83.5631 14.0116 83.5631 12.9404C83.5631 11.8693 83.9222 10.963 84.6429 10.2228C85.3623 9.48263 86.2575 9.11133 87.3287 9.11133C88.3938 9.11133 89.2879 9.48386 90.0109 10.2277C90.734 10.9715 91.0955 11.8754 91.0955 12.9404C91.0955 14.0116 90.7352 14.9179 90.0158 15.658ZM85.3378 15.0437C85.8801 15.5933 86.5434 15.8669 87.3287 15.8669C88.1141 15.8669 88.7785 15.5921 89.3196 15.0437C89.8619 14.494 90.1343 13.793 90.1343 12.9404C90.1343 12.0879 89.8619 11.3868 89.3196 10.8372C88.7785 10.2875 88.1141 10.0139 87.3287 10.0139C86.5434 10.0139 85.8801 10.2888 85.3378 10.8372C84.7968 11.3868 84.5244 12.0879 84.5244 12.9404C84.5244 13.793 84.7968 14.494 85.3378 15.0437Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M92.4171 16.6046V9.27623H93.5628L97.1244 14.9765H97.1647L97.1244 13.5646V9.27623H98.0661V16.6046H97.0829L93.3564 10.6271H93.3161L93.3564 12.039V16.6046H92.4171Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0262 13.2372C58.0262 14.2607 57.7233 15.0754 57.1163 15.6836C56.4274 16.4067 55.5284 16.7682 54.4243 16.7682C53.3666 16.7682 52.4664 16.4018 51.7274 15.669C50.9873 14.9349 50.6172 14.0262 50.6172 12.9416C50.6172 11.8558 50.9873 10.947 51.7274 10.2142C52.4664 9.48013 53.3666 9.11371 54.4243 9.11371C54.9495 9.11371 55.4515 9.21631 55.9278 9.42029C56.4054 9.62548 56.7877 9.89785 57.0735 10.2386L56.4298 10.8835C55.9449 10.3034 55.2768 10.0139 54.4231 10.0139C53.6511 10.0139 52.9843 10.285 52.4212 10.8273C51.8581 11.3696 51.5772 12.0744 51.5772 12.9404C51.5772 13.8063 51.8581 14.5111 52.4212 15.0534C52.9843 15.5957 53.6511 15.8668 54.4231 15.8668C55.2414 15.8668 55.9242 15.5945 56.4701 15.0485C56.8244 14.6931 57.0295 14.1984 57.0845 13.5645H54.4231V12.6839H57.9737C58.0103 12.8756 58.0262 13.0601 58.0262 13.2372Z",
    stroke: "white",
    strokeWidth: 0.24428,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M63.657 10.1764H60.3201V12.4995H63.3297V13.3801H60.3201V15.7032H63.657V16.6046H59.3784V9.27623H63.657V10.1764Z",
    stroke: "white",
    strokeWidth: 0.24428,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6276 16.6046H66.6859V10.1764H64.6389V9.27623H69.6747V10.1764H67.6276V16.6046Z",
    stroke: "white",
    strokeWidth: 0.24428,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3181 16.6046V9.27623H74.2598V16.6046H73.3181Z",
    stroke: "white",
    strokeWidth: 0.24428,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M78.436 16.6046H77.4943V10.1764H75.4472V9.27623H80.483V10.1764H78.436V16.6046Z",
    stroke: "white",
    strokeWidth: 0.24428,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0158 15.658C89.2952 16.3982 88.3999 16.7683 87.3287 16.7683C86.2575 16.7683 85.3623 16.3982 84.6429 15.658C83.9222 14.9179 83.5631 14.0116 83.5631 12.9404C83.5631 11.8693 83.9222 10.963 84.6429 10.2228C85.3623 9.48263 86.2575 9.11133 87.3287 9.11133C88.3938 9.11133 89.2879 9.48386 90.0109 10.2277C90.734 10.9715 91.0955 11.8754 91.0955 12.9404C91.0955 14.0116 90.7352 14.9179 90.0158 15.658ZM85.3378 15.0437C85.8801 15.5933 86.5434 15.8669 87.3287 15.8669C88.1141 15.8669 88.7785 15.5921 89.3196 15.0437C89.8619 14.494 90.1343 13.793 90.1343 12.9404C90.1343 12.0879 89.8619 11.3868 89.3196 10.8372C88.7785 10.2875 88.1141 10.0139 87.3287 10.0139C86.5434 10.0139 85.8801 10.2888 85.3378 10.8372C84.7968 11.3868 84.5244 12.0879 84.5244 12.9404C84.5244 13.793 84.7968 14.494 85.3378 15.0437Z",
    stroke: "white",
    strokeWidth: 0.24428,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M92.4171 16.6046V9.27623H93.5628L97.1244 14.9765H97.1647L97.1244 13.5646V9.27623H98.0661V16.6046H97.0829L93.3564 10.6271H93.3161L93.3564 12.039V16.6046H92.4171Z",
    stroke: "white",
    strokeWidth: 0.24428,
    strokeMiterlimit: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_1007_41961)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8624 9.93316C12.507 10.3093 12.2969 10.8932 12.2969 11.6492V38.6618C12.2969 39.419 12.507 40.0016 12.8624 40.3778L12.9528 40.4658L28.0847 25.3338V25.1555V24.9772L12.9528 9.84399L12.8624 9.93316Z",
    fill: "url(#paint0_linear_1007_41961)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1291 30.3795L28.0859 25.3339V25.1556V24.9773L33.1303 19.9329L33.2439 19.9976L39.2202 23.3931C40.9265 24.3629 40.9265 25.9495 39.2202 26.9205L33.2439 30.316L33.1291 30.3795Z",
    fill: "url(#paint1_linear_1007_41961)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_1007_41961)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.2397 30.3147L28.0805 25.1555L12.8594 40.3779C13.4212 40.9739 14.3507 41.0472 15.3974 40.4536L33.2397 30.3147Z",
    fill: "url(#paint2_linear_1007_41961)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M33.2397 19.9964L15.3974 9.85873C14.3507 9.2639 13.4212 9.33841 12.8594 9.93445L28.0817 25.1568L33.2397 19.9964Z",
    fill: "url(#paint3_linear_1007_41961)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_1007_41961",
    x: 12.2969,
    y: 9.44824,
    width: 28.2031,
    height: 31.4153,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.18321
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1007_41961"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.18321
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_1007_41961",
    result: "effect2_innerShadow_1007_41961"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_1007_41961",
    x: 12.8594,
    y: 25.1555,
    width: 20.3828,
    height: 15.708,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.18321
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1007_41961"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1007_41961",
    x1: 26.7434,
    y1: 11.3634,
    x2: 6.24581,
    y2: 31.861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1007_41961",
    x1: 41.4414,
    y1: 25.1556,
    x2: 11.8884,
    y2: 25.1556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1007_41961",
    x1: 30.4379,
    y1: 27.9573,
    x2: 2.64064,
    y2: 55.7546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1007_41961",
    x1: 9.02588,
    y1: 0.942245,
    x2: 21.4381,
    y2: 13.3545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayAppStore);
export default __webpack_public_path__ + "static/media/play-app-store.3ccd38421efd634c2feb9af8f2877011.svg";
export { ForwardRef as ReactComponent };